namespace Matrix.Data {
    export interface AccountRow {
        AccountCode?: string;
        Name?: string;
        DefaultSortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountTypeCode?: string;
        AccountRoleCode?: string;
        ManagerCode?: string;
        BaseCurrencyCode?: string;
        AssetClass?: string;
        Benchmark1?: string;
        Benchmark2?: string;
        InceptionDate?: string;
        TerminationDate?: string;
        InvestmentObjective?: string;
        PerformanceBenchmark1?: string;
        PerformanceBenchmark2?: string;
        PerformanceInceptionDate?: string;
        PerformanceTerminationDate?: string;
        AccountGroups?: string[];
        HasModelTarget?: boolean;
        EffectiveFrom?: string;
    }

    export namespace AccountRow {
        export const idProperty = 'AccountCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.Account';
        export const lookupKey = 'Data.Account';

        export function getLookup(): Q.Lookup<AccountRow> {
            return Q.getLookup<AccountRow>('Data.Account');
        }
        export const deletePermission = 'DataAdmin:Account';
        export const insertPermission = 'DataAdmin:Account';
        export const readPermission = 'Read:Account';
        export const updatePermission = 'DataAdmin:Account';

        export declare const enum Fields {
            AccountCode = "AccountCode",
            Name = "Name",
            DefaultSortOrder = "DefaultSortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountTypeCode = "AccountTypeCode",
            AccountRoleCode = "AccountRoleCode",
            ManagerCode = "ManagerCode",
            BaseCurrencyCode = "BaseCurrencyCode",
            AssetClass = "AssetClass",
            Benchmark1 = "Benchmark1",
            Benchmark2 = "Benchmark2",
            InceptionDate = "InceptionDate",
            TerminationDate = "TerminationDate",
            InvestmentObjective = "InvestmentObjective",
            PerformanceBenchmark1 = "PerformanceBenchmark1",
            PerformanceBenchmark2 = "PerformanceBenchmark2",
            PerformanceInceptionDate = "PerformanceInceptionDate",
            PerformanceTerminationDate = "PerformanceTerminationDate",
            AccountGroups = "AccountGroups",
            HasModelTarget = "HasModelTarget",
            EffectiveFrom = "EffectiveFrom"
        }
    }
}
